export default __webpack_public_path__ + "static/media/alain_back_group_2.90806e56.png";